import { heOrShe, himOrHer, hisOrHer } from 'projects/sharedComponents/src/services/formatting/sexFormatting';

import { PersonalizedVariableContentFragment } from 'projects/sharedComponents/src/generated/graphql-client-types';

type PersonalizedVariable = {
  variable: string;
  value: string | number;
};

// If you add replaced variables to this function, please update the documentation
// https://embarkvet.atlassian.net/wiki/spaces/PETPAR/pages/59998209/Contentful+For+Editors#Personalized-Content
function getPersonalizedVariableOptions(pet: PersonalizedVariableContentFragment): PersonalizedVariable[] {
  return [
    {
      variable: 'petName',
      value: pet.name,
    },
    {
      variable: 'petNum',
      value: pet.petNum,
    },
    {
      variable: 'hisOrHer',
      value: hisOrHer(pet.sex),
    },
    {
      variable: 'himOrHer',
      value: himOrHer(pet.sex),
    },
    {
      variable: 'heOrShe',
      value: heOrShe(pet.sex),
    },
    {
      variable: 'insuranceUrl',
      value: pet.insuranceUrl,
    },
    {
      variable: 'breed1name',
      value: pet.genotype?.breed1name ?? 'dog',
    },
  ];
}

export function replaceTextPersonalizedVariableContent(
  pet: PersonalizedVariableContentFragment,
  content: string
): string {
  const options = getPersonalizedVariableOptions(pet);
  options.forEach((option) => {
    // I cannot get a replaceAll polyfill to work so do a hacky workaround.
    if (!!content.replaceAll) {
      content = content.replaceAll(`{{${option.variable}}}`, option.value.toString());
    } else {
      const toReplace = `{{${option.variable}}}`;

      while (content.indexOf(toReplace) > -1) {
        content = content.replace(toReplace, option.value.toString());
      }
    }
  });

  return content;
}
